// storage.js

// Function to set an item in local storage
export function setItem(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      // Handle storage error (e.g., exceeding storage quota)
      console.error('Error setting item in local storage:', error);
    }
  }
  
  // Function to get an item from local storage
  export function getItem(key) {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (error) {
      // Handle storage error (e.g., corrupt data)
      console.error('Error getting item from local storage:', error);
      return null;
    }
  }
  
  // Function to remove an item from local storage
  export function removeItem(key) {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      // Handle storage error
      console.error('Error removing item from local storage:', error);
    }
  }
  
  // Function to clear all items from local storage
  export function clearStorage() {
    try {
      localStorage.clear();
    } catch (error) {
      // Handle storage error
      console.error('Error clearing local storage:', error);
    }
  }
  